import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@pattern-library/checkbox';
import { filterPropType } from '../utils/propTypes';
const propTypes = {
  /**
   * The filter object (see `filterPropType` for shape)
   */
  filter: filterPropType.isRequired,
  /**
   * Callback function to handle the checkbox change event
   */
  onChange: PropTypes.func.isRequired,
  /**
   * The current values to apply to the filter
   */
  valuesToApply: PropTypes.arrayOf(PropTypes.string).isRequired
};
function ToggleFilter(_ref) {
  let {
    filter,
    valuesToApply,
    onChange
  } = _ref;
  // ToDo: Update filters to include ID since thats what the checkbox returns
  const updateDefaultFilter = (id, checked) => {
    onChange(filter.toggleLabel, checked);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-form-group"
  }, /*#__PURE__*/React.createElement("span", {
    className: "asc-grid-filter-list-label"
  }, filter.label), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "asc-acc-hidden"
  }, "Select filters"), /*#__PURE__*/React.createElement(Checkbox, {
    id: `filter-${filter.dataKey}`,
    label: filter.toggleLabel,
    isChecked: valuesToApply.length !== 0,
    onChange: updateDefaultFilter
  })), filter.additionalInfo && /*#__PURE__*/React.createElement("div", {
    className: "asc-grid-filter-list-additional-info"
  }, filter.additionalInfo));
}
ToggleFilter.propTypes = propTypes;
export default ToggleFilter;